import styled from 'styled-components'
import Flex from 'Components/Flex'

import {
  OUTLINE_COLOR, CLICKABLE_COLOR, FONT_BASE_COLOR, SELECTED_ITEM_BG_COLOR,
} from '@CSSVars/colors'


export const _ExtraStats = styled.div`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
`
//
// export const _TitleValueBlock = styled(TitleValueBlockV2)`
//   padding: 5px 0 4px;
//   margin: 0 6px!important;
//   flex-basis: calc(50% - 12px);
//   flex-shrink: 1;
//   border-top: 1px solid ${OUTLINE_COLOR};
//
//   &:nth-child(1), &:nth-child(2) {
//     border-top: none;
//   }
//
//   > div {
//     width: 50%;
//
//     &:first-child {
//       text-transform: capitalize;
//     }
//   }
//   div {
//     padding: 0!important;
//     margin: 0!important;
//     line-height: 24px;
//     font-weight: 500!important;
//   }
//   a {
//     padding-left: 0!important;
//     line-height: 24px;
//     font-weight: 500!important;
//     text-align: left!important;
//   }
//
//   @media screen and (max-width: 768px) {
//     margin: 0 0 1px;
//     flex-basis: 100%;
//
//     &:nth-child(2) {
//       border-top: 1px solid ${OUTLINE_COLOR};
//     }
//   }
//
//   @media screen and (max-width: 414px) {
//     padding: 2px 0 2px;
//     && {
//       border-top: none;
//     }
//   }
// `
//
// export const _NoMarginRow = styled(NoMarginRow)`
//   margin: 0 -6px;
// `

export const _ToggleCta = styled(Flex)`
  width: 100%;
  height: 44px;
  padding: 0 20px;
  text-align: center;
  margin-top: 16px;
  border: 1px solid ${OUTLINE_COLOR};
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  color: ${FONT_BASE_COLOR};

  &:hover {
    color: ${CLICKABLE_COLOR};
  }
}

:active {
  color: ${SELECTED_ITEM_BG_COLOR};
}
  svg {
    position: absolute;
    top: 50%;
    transform: ${({ isExtraVisible }) => (!isExtraVisible ? `
      translateY(-50%)
      ` : 'translateY(-50%) rotate(180deg)')};
    right: 14px;
  }

  @media screen and (max-width: 768px) {
    height: 54px;
    padding: 0 55px;
    font-size: 12px;
    line-height: 15px;
  }
`

